import { ExpectedSheetConfiguration } from "./expected-sheet-configuration.interface";

export interface ParsedExcelSheet {
  expectedConfiguration: ExpectedSheetConfiguration;
  actualLastRowNumber?: number;
  hasExpectedHeader?: boolean;
  hasOnlyExpectedHeader?: boolean;
  hasData?: boolean;
  getCellValue?: (headerName: string, rowNumber: number) => string;
  firstColumnValidationError?: ExcelSheetColumnValidationError;
};

export interface ExcelSheetColumnValidationError {
  errorType: ExcelSheetColumnValidationErrorType;
  errorCode: string;
  headerName: string;
  rowNumber: number;
};

export enum ExcelSheetColumnValidationErrorType {
  Mandatory,
  DataType
};
